import {Image} from "@/types";

export type WhyUsType = {
    id: number;
    title: string;
    description: string;
    image: Image;
}
export const whyUs: WhyUsType[] = [
    {
        id: 1,
        title: 'Skilled Team',
        description: 'Trained experts',
        image: {
            id: 1,
            url: '/images/why-us/why1.svg',
            original: '/images/why-us/why1.svg',
            title: 'skilled workers',
        }
    },
    {
        id: 2,
        title: 'Quality Work',
        description: 'Built to last',
        image: {
            id: 2,
            url: '/images/why-us/why2.svg',
            original: '/images/why-us/why2.svg',
            title: 'quality concrete',
        }
    },
    {
        id: 3,
        title: 'Safe Practices',
        description: 'Site compliant',
        image: {
            id: 3,
            url: '/images/why-us/why3.svg',
            original: '/images/why-us/why3.svg',
            title: 'safety first',
        }
    },
    {
        id: 4,
        title: 'On-Time',
        description: 'Projects delivered',
        image: {
            id: 4,
            url: '/images/why-us/why4.svg',
            original: '/images/why-us/why4.svg',
            title: 'on time work',
        }
    },
    {
        id: 5,
        title: 'Modern Methods',
        description: 'Latest systems',
        image: {
            id: 5,
            url: '/images/why-us/why5.svg',
            original: '/images/why-us/why5.svg',
            title: 'modern construction',
        }
    },
    {
        id: 6,
        title: 'Trusted Results',
        description: 'Proven projects',
        image: {
            id: 6,
            url: '/images/why-us/why6.svg',
            original: '/images/why-us/why6.svg',
            title: 'reliable results',
        }
    }
];



